import Vue from 'vue';
import BookingHelper from '@/store/booking_stores/BookingHelper';
import helpers from '../../../helpers';

export default ({$moment: moment} = {}) => {
  return {
    namespaced: true,
    state: {
      seriesDateOneSupplierSelect: false,
      seriesLanguageOneSupplierSelect: false,
      jobSeries: [],
      errors: {
        dateTimesOverlapping: {name: 'dateTimesOverlappingTimeValidation', errors: []}
      }
    },
    actions: {
      changeFinishTime({state, commit}, index) {
        const [startHours, startMinutes] = moment(state.jobSeries[index].startTime).format('HH:mm').split(':');
        const assignmentStartTime = moment()
          .hours(startHours)
          .minutes(startMinutes)
          .seconds(0)
          .milliseconds(0);
        const [finishHours, finishMinutes] = moment(state.jobSeries[index].finishTime).format('HH:mm').split(':');
        const assignmentFinishTime = moment()
          .hours(finishHours)
          .minutes(finishMinutes)
          .seconds(0)
          .milliseconds(0);
        const diff = assignmentStartTime.diff(assignmentFinishTime);
        const newFinishDate = diff >= 0
          ? moment(state.jobSeries[index].startTime).add(1, 'day')
          : moment(state.jobSeries[index].startTime);
        const expectedFinishTime = assignmentFinishTime.format('HH:mm');
        const expectedFinishDate = moment(newFinishDate).format('YYYY-MM-DD');

        commit('executeNotTrackedMutation', {
          mutationName: 'PostingStore/SeriesAssignmentStore/setAssignmentFinishDate',
          payload: {
            index,
            value: expectedFinishDate
          }
        }, {root: true});
        commit('executeNotTrackedMutation', {
          mutationName: 'PostingStore/SeriesAssignmentStore/setFinishTime',
          payload: {
            index,
            value: expectedFinishTime
          }
        }, {root: true});
      },
      setStartTime({state, rootGetters, commit}, {index, value}) {
        commit('setStartTime', {index, value});

        const newVal = state.jobSeries[index].startTime;
        const duration = rootGetters['UserInfoStore/defaultJobDuration'];
        const expectedFinishTime = moment(newVal).add(duration, 'minutes').format('HH:mm');
        const expectedFinishDate = moment(newVal).add(duration, 'minutes').format('YYYY-MM-DD');

        commit('executeNotTrackedMutation', {
          mutationName: 'PostingStore/SeriesAssignmentStore/setAssignmentFinishDate',
          payload: {
            index,
            value: expectedFinishDate
          }
        }, {root: true});
        commit('executeNotTrackedMutation', {
          mutationName: 'PostingStore/SeriesAssignmentStore/setFinishTime',
          payload: {
            index,
            value: expectedFinishTime
          }
        }, {root: true});
        commit('resetDateTimesOverlappingError');
      },
      setFinishTime({dispatch, commit}, {index, value}) {
        commit('setFinishTime', {index, value});
        dispatch('changeFinishTime', index);
        commit('resetDateTimesOverlappingError');
      },
      preselectDateTimes({state, dispatch}) {
        state.jobSeries = [];
        dispatch('addAssignment');
      },
      addAssignment({state, commit, rootState, rootGetters}) {
        const jobSeries = state.jobSeries;
        const duration = rootGetters['UserInfoStore/defaultJobDuration'];
        const lastJob = jobSeries[jobSeries.length - 1];
        const lastLanguageToId = lastJob?.languageToId || '';
        let newItem;

        if (jobSeries.length >= 1) {
          const lastSeriesJobStartDate = moment(lastJob.startTime);
          const newSeriesDate = moment(lastSeriesJobStartDate).clone().add(1, 'days');

          newItem = {
            startTime: newSeriesDate,
            finishTime: '',
            languageToId: lastLanguageToId
          };
        } else {
          const defaultStartTime = rootState.PostingStore.DateTimeStore.startTime || '';
          newItem = {
            startTime: defaultStartTime,
            finishTime: '',
            languageToId: lastLanguageToId
          };
        }

        const updatedSeries = [...jobSeries, newItem];
        Vue.set(state, 'jobSeries', updatedSeries);

        const index = updatedSeries.length - 1;

        Vue.set(state.errors, `startTime${index}`, {
          name: `startTimeValidation${index}`,
          errors: []
        });

        Vue.set(state.errors, `finishTime${index}`, {
          name: `finishTimeValidation${index}`,
          errors: []
        });

        const earliestStartTime = rootGetters['UserInfoStore/urgentBookingsBlocked']
          ? helpers.dateTime.earliestNonUrgentStartTime(moment)
          : null;
        commit('setPreselectedTime', {index, duration, earliestStartTime});
      },
      deleteDateTime({commit}, index) {
        commit('deleteDateTime', index);
        commit('resetDateTimesOverlappingError');
      },
      setDate({commit, dispatch}, {index, value}) {
        commit('setDate', {index, value});
        dispatch('changeFinishTime', index);
        commit('resetDateTimesOverlappingError');
      },
      changeSeriesDateOneSupplierSelect({commit}, value) {
        commit('resetDateTimesOverlappingError');
        commit('setSeriesDateOneSupplierSelect', value);
      },
    },
    mutations: {
      ...BookingHelper().mutations,
      resetDateTimesOverlappingError(state) {
        state.errors.dateTimesOverlapping.errors = [];
      },
      setSeriesDateOneSupplierSelect(state, value) {
        state.seriesDateOneSupplierSelect = value;
      },
      setSeriesLanguageOneSupplierSelect(state, value) {
        state.seriesLanguageOneSupplierSelect = value;
      },
      setLanguage(state, {index, value}) {
        state.jobSeries[index].languageToId = value;
      },
      // only date change
      setDate(state, {index, value}) {
        state.jobSeries[index].startTime = helpers.dateTime.setDate(moment, {
          currentTime: state.jobSeries[index].startTime,
          value
        });
        state.jobSeries[index].finishTime = helpers.dateTime.setDate(moment, {
          currentTime: state.jobSeries[index].finishTime,
          value
        });
      },
      setAssignmentFinishDate(state, {index, value}) {
        const finishTime = state.jobSeries[index].finishTime;
        state.jobSeries[index].finishTime = helpers.dateTime.setDate(moment, {
          currentTime: finishTime,
          value
        });
      },
      // only start time change
      setStartTime(state, {index, value}) {
        state.jobSeries[index].startTime = helpers.dateTime.setTime(moment, {
          currentTime: state.jobSeries[index].startTime,
          value
        });
      },
      // only finish time change
      setFinishTime(state, {index, value}) {
        state.jobSeries[index].finishTime = helpers.dateTime.setTime(moment, {
          currentTime: state.jobSeries[index].finishTime,
          value
        });
      },
      // only for initial time preselection
      setPreselectedTime(state, {index, duration, earliestStartTime}) {
        const [hours, minutes] = earliestStartTime
          ? earliestStartTime.format('HH:mm').split(':')
          : helpers.dateTime.convertCurrentTime(moment).split(':');
        let startTime = state.jobSeries[index].startTime;

        if (startTime == null || startTime == '') {
          startTime = moment()
            .hours(+hours)
            .minutes(+minutes)
            .seconds(0)
            .milliseconds(0);
        } else {
          startTime = moment(startTime)
            .hours(+hours)
            .minutes(+minutes)
            .seconds(0)
            .milliseconds(0);
        }
        if (earliestStartTime && startTime.isBefore(earliestStartTime)) {
          startTime = moment(earliestStartTime);
        }
        state.jobSeries[index].startTime = startTime;

        // take startTime as the starting point of the time calculation finish time
        state.jobSeries[index].finishTime = moment(startTime)
            .hours(+hours)
            .minutes(+minutes)
            .seconds(0)
            .milliseconds(0)
            .add(duration, 'minutes');
      },
      deleteDateTime(state, index) {
        state.jobSeries.splice(index, 1);
        state.errors[`startTime${index}`] = {name: `startTimeValidation${index}`, errors: []};
      },
      clearStore(state) {
        state.seriesDateOneSupplierSelect = false;
        state.seriesLanguageOneSupplierSelect = false;
        state.jobSeries = [];
        state.errors = {
          dateTimesOverlapping: {name: 'dateTimesOverlappingTimeValidation', errors: []},
          languageToId: {name: 'languageToIdValidation', errors: []}
        };
      }
    }
  };
};
